module.exports = __webpack_public_path__ + "img/super.528b67b3.png";